import gql from 'graphql-tag'

export default gql`
  query NationalHomepage($country: String!) {
    cfNationalHomepageCollection(
      limit: 1
      where: { country_contains_all: [$country] }
    ) {
      items {
        navigationMenu
      }
    }
  }
`
